import { put } from '@api/api';

export type IUpdateOrganizationsPayload = {
  id: number;
  name: string;
  active: boolean;
  flags: string[];
  requiresTwoFactorAuthentication: boolean;
  allowsTwoFactorAuthenticationRememberMe: boolean;
};

export function updateOrganization(
  id: number,
  toUpdate: IUpdateOrganizationsPayload
) {
  return put(`/organization/${id}`, toUpdate);
}
